import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
}, km({
    COLLEAGUESBUYSHARE_GETGROUPINFO_SUCCESS: null,
    COLLEAGUESBUYSHARE_GETGROUPINFO_ERROR: null,
    COLLEAGUESBUYSHARE_GETPRODUCTLIST_SUCCESS: null,
    COLLEAGUESBUYSHARE_GETPRODUCTLIST_ERROR: null,
    COLLEAGUESBUYSHARE_GET_COMMUNITY_LIST_SUCCESS: null,
    COLLEAGUESBUYSHARE_GET_COMMUNITY_LIST_ERROR: null
}))